export const getInitials = (name: string): string => {

  // making some assumptions here, and this is pretty simple,
  // not covering any edge cases at all at this point
  const parts = name.split(' ').slice(0, 2);

  return parts.reduce((a, c) => {
    return a + c.substring(0, 1).toUpperCase();
  }, '');

};

// Prefers split fields; falls back to legacy `name` until LCX-965 backfill.
export const getPatientFullName = (
  patient: { nameFirst?: string; nameLast?: string; name?: string }
): string => {
  const split = `${patient.nameFirst || ''} ${patient.nameLast || ''}`.trim();
  return split || patient.name || '';
};
